
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { OfferSingle } from "@/services/offers/OfferSingle";
import { translateBoolean } from "@/utils/translate";
import { IEditableOfferFields } from "@/api/types/offers";
import BaseCard from "@/components/base/BaseCard.vue";
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";
import { useOfferDetailStore } from "@/store_v3/offerCard";
import { canEditOffers } from "@/utils/checkRole";
import BaseInputNumber from "@/components-UI/BaseInputNumber.vue";
import { pluralRu } from "@/utils/formatDates";

interface IOption {
    id: string;
    name: string;
    value: any;
    sup?: string;
    isEditable: boolean;
    tooltip?: string;
}

@Component({
    components: {
        BaseInputNumber,
        BaseCard,
        QuestionMarkTooltip: BaseQuestionMarkTooltip,
    },
})
export default class OfferCardSettings extends Vue {
    get canEditOffer(): boolean {
        return canEditOffers();
    }

    @Prop({ required: true }) offer!: OfferSingle;
    @PropSync('isLoading') isLoadingSync!: boolean;

    isEdit = false;
    offerData: IEditableOfferFields = {} as IEditableOfferFields;
    translateBoolean = translateBoolean;
    store = useOfferDetailStore();

    get getOptions(): IOption[] {
        return [
            {
                id: 'private',
                name: 'Приватность',
                value: this.offer.private,
                isEditable: true,
            },
            {
                id: 'requires_approval',
                name: 'Требует подтверждения',
                sup: 'confirmations',
                value: this.offer.confirmations.requires_approval,
                isEditable: true,
                tooltip: 'Согласование с менеджером вебмастера, менеджер сам решает, давать доступ или нет.',
            },
            {
                id: 'requires_advertiser_approval',
                name: 'Требует согласования',
                sup: 'confirmations',
                value: this.offer.confirmations.requires_advertiser_approval,
                isEditable: true,
                tooltip: 'Согласование с рекламодателем.',
            },
            {
                id: 'offer_for_clicks',
                name: 'Лиды из кликов',
                value: this.offer.offer_for_clicks,
                isEditable: true,
                tooltip: 'При включении этой опции, для данного оффера будут автоматически создаваться конверсии из уникальных кликов.',
            },
            {
                id: 'hold_days',
                name: 'Холд',
                value: this.offer.hold_days,
                isEditable: true,
            },
        ];
    }

    editInfo(edit: boolean): void {
        if (edit) {
            this.setValues();
        } else {
            this.updateOffer();
        }
        this.isEdit = edit;
    }

    cancelEdit(): void {
        this.isEdit = false;
    }

    setValues(): void {
        this.getOptions.forEach(opt => {
            this.offerData[opt.id] = opt.sup ? this.offer[opt.sup][opt.id] : this.offer[opt.id];
        });
    }

    getPlural(days: number): string {
        return pluralRu(days, ['день', 'дня', 'дней']);
    }

    async updateOffer(): Promise<void> {
        this.isLoadingSync = true;
        const isUpdate = await this.offer.editOffer(this.offerData);
        if (isUpdate) this.store.setIsUpdateOffer(true);
        this.isLoadingSync = false;
        this.$emit('update-offer');
    }
}
